import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap, switchMap, skipWhile } from 'rxjs/operators';
import { AppState, selectAccountState } from 'src/app/core/reducers';
import { JwtService } from '../services/jwt.service';
import { isNotAuth } from '../store';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private jwtService: JwtService
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(selectAccountState),
      map((selectAccountState) => {
        return selectAccountState.isLoading;
      }),
      skipWhile((isLoading) => isLoading),
      switchMap(() => {
        return this.store.pipe(
          select(isNotAuth, this.jwtService.getToken()),
          tap((notAuthed) => {
            if (!notAuthed) {
              this.router.navigate(['/']);
            }
          })
        );
      })
    );
  }
}
